import styled from 'styled-components'

import { color, space, SpaceProps, typography } from '../../../../themes'

export const Container = styled.div<SpaceProps>`
  ${space};
`

export const Item = styled.div`
  ${typography('body2')};
  color: ${color('gray.01')};
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    color: ${color('gray.02')};
    flex-shrink: 0;
  }
`
